import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getInstalledProvidersOptInStatus, getMeeting, getService, listAvailability, listCalendars, listMeetings, queryServices, searchServices, updateProviderOptStatus } from '@wix/ambassador-asa-service-facade-v1-service/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { ServicesFacadeClientBase } from './ServicesFacadeClientBase';
export class ServicesFacadeClient extends HttpBaseClient(ServicesFacadeClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "listCalendarsImpl", listCalendars);
    _defineProperty(this, "listMeetingsImpl", listMeetings);
    _defineProperty(this, "queryServicesImpl", queryServices);
    _defineProperty(this, "searchServicesImpl", searchServices);
    _defineProperty(this, "getServiceImpl", getService);
    _defineProperty(this, "getInstalledProvidersOptInStatusImpl", getInstalledProvidersOptInStatus);
    _defineProperty(this, "listAvailabilityImpl", listAvailability);
    _defineProperty(this, "updateProviderOptStatusImpl", updateProviderOptStatus);
    _defineProperty(this, "getMeetingImpl", getMeeting);
  }
}
//# sourceMappingURL=ServicesFacadeClientHttp.js.map